import { Button, Icon } from 'kui';
import * as React from 'react';
import { markdown } from '../../../../../../../../helper/markdownHelper';
import { TCardId } from '../../../../../../../../types/types';
import {
    CARD_SECTION_SUBCARDS,
    CARD_SUBCARDS_DONE
} from '../../../../../../aside_panel/cardDetails/SubcardsSection/components/CardSubcardsSection/constants';
import { CARD_CLASS, CARD_CONTROL_CLASS } from '../../../../constants';
import { ICardSubcard, ICardSubcardsProps } from './types';
import './_CardSubcards.scss';
import { getMessages } from '../../../../../../../../store/constants';
import ReactHtmlParser from 'react-html-parser';
import { onImgLoad } from '../../../helpers/onImgLoad';

export function CardSubcards ({
    className,
    elements,
    isClone,
    setCardHeight,
    onHeightChange,
    onSubcardLink,
    onToggleLoadingImg,
    subcardsStats,
}: ICardSubcardsProps) {
    const classElement = CARD_CLASS + '__subcards';
    const classTitle = classElement + '-title';
    const classProgress = classElement + '-progress';

    React.useEffect(() => {
        if (setCardHeight) {
            setCardHeight();
        }
    }, [elements]);

    return (
        <div
            className={`
                ${className}
                ${classElement}
            `}
        >
            <div className={classTitle}>
                <div className={classTitle + '-text'}>
                    {CARD_SECTION_SUBCARDS}
                </div>
                {subcardsStats && !!subcardsStats.totalCount &&
                    <div className={classProgress}>
                        {getMessages().getText(
                            CARD_SUBCARDS_DONE,
                            null,
                            subcardsStats.donePercent,
                            subcardsStats.doneCount,
                            subcardsStats.totalCount
                        )
                        }
                    </div>
                }
            </div>
            {elements.map(subcard => {
                return <Item
                    {...subcard}
                    key={subcard.id}
                    isClone={isClone}
                    onHeightChange={onHeightChange}
                    onSubcardLink={onSubcardLink}
                    onToggleLoadingImg={onToggleLoadingImg}
                />
            })}
        </div>
    );
}

function Item ({
    cardNumber,
    fullName,
    icon,
    isClone,
    id,
    link,
    name,
    processingPercent,
    onHeightChange,
    onSubcardLink,
    onToggleLoadingImg,
}: ICardSubcard) {
    const classItem = CARD_CLASS + '-subcard';
    const classColumn = classItem + '__col';
    const classColumnName = classColumn + ' ' + classColumn + '--name';
    const classColumnProgress = classColumn + ' ' + classColumn + '--progress';
    const classItemNumber = classItem + '__number';

    if (isClone) return <div className={classItem + '--fake'} />;
    function onSubcardLinkHandler(event: React.MouseEvent, cardId: TCardId) {
        event.preventDefault();
        event.stopPropagation();
        onSubcardLink(cardId);
    }

    const ref = React.useRef(null);
    const [markdownName, setMarkdownName] = React.useState('');
    React.useEffect(() => {
        setMarkdownName(markdown(name));
    }, [name]);

    React.useEffect(() => {
        if (!onHeightChange || !markdown || !ref.current) return;
        const cleanup = onImgLoad(ref.current, onHeightChange, onToggleLoadingImg);
        return cleanup;
    }, [markdown]);

    return (
        <Button
            className={`
                    ${classItem}
                    ${CARD_CONTROL_CLASS}
                `}
            href={link}
            tooltip={{
                isNoEvents: true,
                isNoWrap: true,
                value: markdown(fullName)
            }}
            variant={'icon-text'}
            onClick={(event: React.MouseEvent) => onSubcardLinkHandler(event, id)}
        >
            <Icon className={classItem + '__icon'} size={16} xlink={icon} />
            <div className={classColumnName} ref={ref}>
                {!!cardNumber &&
                    <span className={classItemNumber}>
                        {cardNumber}
                    </span>
                }
                {ReactHtmlParser(markdownName)}
            </div>
            <div className={classColumnProgress}>
                {processingPercent}%
            </div>
        </Button>
    );
}
